export const Checkbox = {
  parts: ['control', 'label'],
  baseStyle: {
    marginBottom: '0',
    control: {
      w: '100%',
      transitionProperty: 'box-shadow',
      transitionDuration: 'normal',
      border: '1px solid',
      borderRadius: '3px',
      borderColor: 'brand.input-border',
      color: 'brand.btn-alt',

      _checked: {
        bg: 'brand.btn',
        borderColor: 'brand.btn',
        color: 'brand.btn-alt',
        opacity: 1,

        _hover: {
          bg: 'brand.btn',
          borderColor: 'brand.btn'
        },

        _disabled: {
          bg: 'brand.input-border',
          borderColor: 'transparent',
          color: 'brand.btn-alt'
        }
      },

      _indeterminate: {
        bg: 'brand.btn',
        borderColor: 'brand.btn',
        color: 'brand.btn-alt'
      },

      _disabled: {
        bg: 'transparent',
        borderColor: 'brand.input-border',
        opacity: 0.2
      },

      _focus: {
        boxShadow: 'outline'
      },

      _invalid: {
        borderColor: 'error'
      }
    },
    label: {
      marginBottom: 0,
      fontWeight: 'bold'
    }
  },
  sizes: {
    sm: {
      label: {
        fontSize: 'xs'
      }
    },
    md: {
      label: {
        fontSize: 'sm'
      }
    },
    lg: {
      label: {
        fontSize: 'md'
      }
    }
  },
  defaultProps: {
    size: 'md'
  }
}
